const trackingConstants = {
    TRACKING_ON_VIEW: {
        event_category: 'Internal Promotions',
        event_id: 'view',
        event_type: 'AREA_VISIBLE',
        promotion_creative: [''],
        promotion_id: [''],
        promotion_name: [''],
        promotion_position: 'array',
        page_id: [''],
        page_category_id: [''],
    },
    TRACKING_ON_CTA_CLICK: {
        event_type: 'PROMOTIONCLICK',
        event_category: 'Internal Promotions',
        event_id: 'click',
        promotion_creative: [''],
        promotion_id: [''],
        promotion_name: [''],
        promotion_position: 'array',
        page_id: [''],
        page_category_id: [''],
    },
};
export default trackingConstants;
//# sourceMappingURL=trackingConstants.js.map